import ApiClient from './ApiClient';

class AiAgentsAPI extends ApiClient {
  constructor() {
    super('ai_agents', { accountScoped: true });
  }

  getAgents() {
    return this.get();
  }

  getAgent(agentId) {
    return this.show(agentId);
  }

  createAgent(payload) {
    return this.create({ ai_agent: payload });
  }

  updateAgent(agentId, payload) {
    return this.update(agentId, { ai_agent: payload });
  }

  deleteAgent(agentId) {
    return this.delete(agentId);
  }
}

export default new AiAgentsAPI();
